import { SettingsApiResponseModel } from './services/api/types';

export interface IAppSettings extends SettingsApiResponseModel {}

export interface ISettingsCache {
  settings: IAppSettings;
  profileId: string;
  appToken: string;
}

export const Settings: ISettingsCache = {
  profileId: null,
  appToken: null,
  settings: {
    features: [],
    links: {},
  },
};
